import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Operador } from '../../types/pessoas';
import { operadoresService } from '../../services';

const fields: ResourceField<Operador>[] = [
  { name: 'nome', label: 'Nome', required: true },
  { name: 'cargo', label: 'Cargo', type: 'select', options: [{ label: 'Operador', value: 'OPERADOR' }, { label: 'Supervisor', value: 'SUPERVISOR' }, { label: 'Técnico', value: 'TECNICO' }, { label: 'Analista', value: 'ANALISTA' }, { label: 'Outros', value: 'OUTROS' }] },
  { name: 'status', label: 'Status', type: 'select', options: [{ label: 'Ativo', value: 'ATIVO' }, { label: 'Licença', value: 'LICENCA' }, { label: 'Férias', value: 'FERIAS' }, { label: 'Demitido', value: 'DEMITIDO' }] },
  { name: 'data_admissao', label: 'Data de admissão', type: 'date' },
  { name: 'qualificacoes', label: 'Qualificações', type: 'textarea' }
];

export const OperadoresFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo operador"
    description="Cadastre membros da equipe operacional."
    fields={fields}
    service={ operadoresService }
    redirectPath="/admin/pessoas/operadores"
    cancelPath="/admin/pessoas/operadores"
  />
);
